import { defaultStylingSchema } from '../schema';

export const SeparatorStylingSchema = ({ schema, formData, intl }) => {
  defaultStylingSchema({ schema, formData, intl });

  return schema;
};
